import { DefaultConfigModuleConstant } from "../constants/DefaultConfig.constant";

const initialState = {
    walletThresholdDefaults: {},
    walletThresholdDefaultsStatus: '',
    configurationDefaults: {},
    configurationDefaultsStatus: '',
};

export default function DefaultConfigReducer(state = initialState, action = '') {
    const { type, payload } = action;
    switch (type) {
        case DefaultConfigModuleConstant.WALLET_THRESHOLD_DEFAULTS_PENDING:
            return {
                ...state,
                walletThresholdDefaults: {},
                walletThresholdDefaultsStatus: 'pending'
            };
        case DefaultConfigModuleConstant.WALLET_THRESHOLD_DEFAULTS_SUCCESS:
            return {
                ...state,
                walletThresholdDefaults: payload,
                walletThresholdDefaultsStatus: 'success'
            };
        case DefaultConfigModuleConstant.WALLET_THRESHOLD_DEFAULTS_FAILURE:
            return {
                ...state,
                walletThresholdDefaults: {},
                walletThresholdDefaultsStatus: 'failure'
            };
        case DefaultConfigModuleConstant.CONFIGURATION_DEFAULTS_PENDING:
            return {
                ...state,
                configurationDefaults: {},
                configurationDefaultsStatus: 'pending'
            };
        case DefaultConfigModuleConstant.CONFIGURATION_DEFAULTS_SUCCESS:
            return {
                ...state,
                configurationDefaults: payload,
                configurationDefaultsStatus: 'success'
            };
        case DefaultConfigModuleConstant.CONFIGURATION_DEFAULTS_FAILURE:
            return {
                ...state,
                configurationDefaults: {},
                configurationDefaultsStatus: 'failure'
            };
        default:
            return state;
    }
}
